// extracted by mini-css-extract-plugin
export default {"Card":"CityCard_Card__iEeZ5","Cover":"CityCard_Cover__7+uCn","Title":"CityCard_Title__tXV1p","TitleSkeleton":"CityCard_TitleSkeleton__0dxXX"};